import React from "react";
import Autocomplete from '@mui/material/Autocomplete';
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import AddIcon from "@mui/icons-material/Add";
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { withStyles } from "@mui/styles";

import { ConfirmCancelDialog } from "../ConfirmCancelDialog";
import { LanguageContext } from '../LanguageContext';
import Osoitehaku from "./Osoitehaku";

const defaultToolbarStyles = {
    iconButton: {
    },
};


class KustannuspaikkaAdd extends React.Component {
    static contextType = LanguageContext;
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            RiviAvain: null,
            EmoKustannuspaikkaAvain: null,
            OrganisaatioAvain: null,
            Nimi: null,
            Kuvaus: null,
            OsoiteId: null,
            Katuosoite: null,
            Created: null,
            Updated: null,
            Username: null,
            organisaatiot: (Object.keys(props.lookupLists.organisaatiot).map((d) => ({ value: d, label: props.lookupLists.organisaatiot[d] })) || []),
            kustannuspaikat: (Object.keys(props.lookupLists.kustannuspaikat).map((d) => ({ value: d, label: props.lookupLists.kustannuspaikat[d] })) || []),
        };
    }

    handleClearData = () => {
        this.setState({
            open: false,
            setOpen: false,
            jotainMuuttui: false,
            openAddressSearch: false,
            RiviAvain: null,
            EmoKustannuspaikkaAvain: null,
            OrganisaatioAvain: null,
            Nimi: null,
            Kuvaus: null,
            OsoiteId: null,
            Katuosoite: null,
            Created: null,
            Updated: null,
            Username: null
        });
    }

    handleSave = () => {
        this.props.onAddNewRow({
            RiviAvain: 1,
            EmoKustannuspaikkaAvain: this.state.EmoKustannuspaikkaAvain,
            OrganisaatioAvain: this.state.OrganisaatioAvain,
            Nimi: this.state.Nimi,
            Kuvaus: this.state.Kuvaus,
            OsoiteId: this.state.OsoiteId,
            Katuosoite: this.state.Katuosoite,
            Created: this.state.Created,
            Updated: this.state.Updated,
            Username: this.state.Username,
        });

        this.handleClearData();
    };

    closeDialog = (list) => {
        var name = 'open' + list;
        this.setState({ [name]: false })
    };

    handleAddressSelect = (osoite) => {
        this.setState({
            OsoiteId: osoite.riviAvain,
            Katuosoite: osoite.katuosoite,
            openAddressSearch: false,
            jotainMuuttui: true
        })
    }

    handleAddressSearchClose = (event) => {
        this.setState({ openAddressSearch: false });
    }

    handleAddressSearchOpen = (event) => {
        this.setState({ openAddressSearch: true });
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
            jotainMuuttui: true
        });
    };

    handleClickOpen = () => {
        this.setState({
            open: true,
        });
    }

    handleListChange = (event, newValue, item) => {
        if (newValue != null) {
            this.setState({ [item]: newValue.value })
        }
        else {
            this.setState({ [item]: null })
        }
        this.setState({ jotainMuuttui: true });
    }

    handleClose = () => {
        if (this.state.jotainMuuttui) {
            this.setState({
                setOpen: true
            });
        }
        else {
            this.setState({
                open: false,
                setOpen: false
            });
        }
    }

    handleSetOpenCancel = () => {
        this.setState({
            open: true,
            setOpen: false
        });
    }

    render() {
        const { dictionary } = this.context;
        const { open, openAddressSearch, organisaatiot, kustannuspaikat } = this.state;

        return (
            <React.Fragment>
                <Tooltip title={dictionary.Toolbar.NewRow}>
                    <IconButton onClick={this.handleClickOpen}>
                        <AddIcon />
                    </IconButton>
                </Tooltip>

                <Dialog open={open} onClose={this.handleClose}>
                    <DialogTitle>{dictionary.Inventory.Kustannuspaikka.Title}</DialogTitle>
                    <DialogContent style={{ width: "500px" }}>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'EmoKustannuspaikkaAvain')}
                                options={kustannuspaikat}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Inventory.Kustannuspaikka.Columns[1]} />}
                            />
                        </Box>
                        <Box style={{ display: 'flex', paddingTop: "10px" }} >
                            <Autocomplete
                                onChange={(event, newValue) => this.handleListChange(event, newValue, 'OrganisaatioAvain')}
                                options={organisaatiot}
                                style={{ width: 400 }}
                                renderInput={(params) => <TextField  {...params} required={true} variant="standard" label={dictionary.Inventory.Kustannuspaikka.Columns[2]} />}
                            />
                        </Box>
                        <TextField
                            required
                            margin="dense"
                            id="Nimi"
                            label={dictionary.Inventory.Kustannuspaikka.Columns[3]}
                            type="text"
                            fullWidth
                            value={this.state.Nimi}
                            onChange={this.handleChange('Nimi')}
                        />
                        <TextField
                            margin="dense"
                            id="Kuvaus"
                            label={dictionary.Inventory.Kustannuspaikka.Columns[4]}
                            type="text"
                            fullWidth
                            value={this.state.Kuvaus}
                            onChange={this.handleChange('Kuvaus')}
                        />
                        <Box style={{ display: 'flex', alignItems: "center" }} >
                            <Button
                                variant="outlined"
                                color="primary"
                                onClick={this.handleAddressSearchOpen}
                                style={{ heioght: 36, marginRight: 8 }}
                            >
                                {dictionary.Inventory.Osoitehaku.Title}
                            </Button>
                            <TextField
                                margin="dense"
                                id="Katuosoite"
                                InputProps={{
                                    readOnly: true,
                                }}
                                required
                                label={dictionary.Inventory.Organisaatio.Columns[6]}
                                type="text"
                                fullWidth
                                value={this.state.Katuosoite}
                            />
                        </Box>
                    </DialogContent>
                    <DialogActions
                        style={{ backgroundColor: "#3C495A" }}
                    >
                        <ButtonGroup variant="comboButton">
                            <Button variant="Secondary" onClick={this.handleClose}>
                                {dictionary.Close}
                            </Button>
                            <Button variant="Primary" onClick={this.handleSave}>
                                {dictionary.Save}
                            </Button>
                        </ButtonGroup>
                    </DialogActions>
                </Dialog>
                <Osoitehaku
                    open={openAddressSearch}
                    pca={this.props.pca}
                    onSelected={this.handleAddressSelect}
                    onClose={this.handleAddressSearchClose}
                />
                <ConfirmCancelDialog
                    open={this.state.setOpen}
                    onCancel={this.handleSetOpenCancel}
                    onOk={this.handleClearData}
                />
            </React.Fragment>
        );
    }
}

export default withStyles(defaultToolbarStyles, { name: "KustannuspaikkaAdd" })(KustannuspaikkaAdd);
